import React, { forwardRef } from "react";
import MuiAutocomplete, {
  type AutocompleteProps,
} from "@material-ui/lab/Autocomplete";

import Popper from "./Popper";

export type { AutocompleteProps };

/** This is just a wrapper of Mui's Popper that patches `container` property to make
 * the autocomplete work in fullscreen mode.
 */
const Autocomplete = forwardRef(
  <
    T,
    Multiple extends boolean | undefined = undefined,
    DisableClearable extends boolean | undefined = undefined,
    FreeSolo extends boolean | undefined = undefined
  >(
    props,
    ref
  ) => (
    <MuiAutocomplete<T, Multiple, DisableClearable, FreeSolo>
      ref={ref}
      PopperComponent={Popper}
      {...props}
    />
  )
);

export default Autocomplete as typeof MuiAutocomplete;
